import { request, RequestDocument, Variables } from 'graphql-request'

/**
 * Makes a GraphQL request with authorization header from localStorage
 *
 * @param document - GraphQL query or mutation
 * @param variables - Variables for the GraphQL operation
 * @returns Promise with the response data
 */
export const authorizedGraphQLRequest = async <T = any>(
  document: RequestDocument,
  variables?: Variables,
): Promise<T> => {
  // Get the GraphQL endpoint URL from environment variables
  const endpoint = import.meta.env.VITE_API_GRAPHQL_URL || ''

  // Get auth token from localStorage
  const token = localStorage.getItem('auth_token')

  // Add authorization header if token exists
  const headers: HeadersInit = {}
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  // Make the request with headers
  return request<T>(endpoint, document, variables, headers)
}
